import { render, staticRenderFns } from "./Pemaparandokumen.vue?vue&type=template&id=09b9afd8"
import script from "./Pemaparandokumen.vue?vue&type=script&lang=js"
export * from "./Pemaparandokumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports